/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Output_Language_PlaceholderInputs */



/**
* | output |
* | --- |
* | "e.g. eng" |
*
* @param {Audio_Embed_Export_Output_Language_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_output_language_placeholder = /** @type {((inputs?: Audio_Embed_Export_Output_Language_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Output_Language_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("par exemple eng")
	if (locale === "de") return /** @type {LocalizedString} */ ("z.B. eng")
	if (locale === "it") return /** @type {LocalizedString} */ ("ad esempio inglese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("например, eng")
	if (locale === "es") return /** @type {LocalizedString} */ ("p. ej. inglés")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("例如 eng")
	if (locale === "ja") return /** @type {LocalizedString} */ ("例：英語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उदाहरण के लिए, अंग्रेजी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("por exemplo, eng")
	return /** @type {LocalizedString} */ ("e.g. eng")
});